import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";

export const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    api.post("/auth/session", { session_id: sessionId })
      .then(({ data }) => navigate("/organiser", { replace: true, state: { user: data } }))
      .catch(() => navigate("/organiser", { replace: true }));
  }, [location.hash, navigate]);

  return (
    <div className="nobo">
      <div className="wrap"><p className="lede" data-testid="auth-callback">signing you in...</p></div>
    </div>
  );
};
